import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import Showcase from './Showcase'

import { ProductProvider } from './Hooks/productStates'

const ShowcaseContainer = () => {
  const data = useStaticQuery(graphql`
    {
      wordpressWpGatsbyPage(slug: { eq: "exames" }) {
        acf {
          subtitle
          demonstrative_text
          banner_sidebar {
            image_desktop {
              source_url
              alt_text
            }
            image_mobile {
              source_url
              alt_text
            }
            active
            link
          }
          top_searchs_title
          top_searchs
          title
          description
          product_budget
        }
      }
      negotiationCode: wordpressExecutiveThemeSettings {
        negotiation_code
      }
      allWordpressAcfMostWantedExams {
        edges {
          node {
            acf {
              exam_id
              exam_name
              exam_link
              exams_order
              covered_health_insurance
            }
          }
        }
      }
      allMostWantedExams {
        nodes {
          exam_id
          exam_name
          covered_health_insurance
          exam_link
          exam_price
          exams_order
        }
      }
    }
  `)

  const productsData = {
    type: 'exams',
    title: data.wordpressWpGatsbyPage.acf.subtitle,
    demonstrative_text: data.wordpressWpGatsbyPage.acf.demonstrative_text,
    bannerSidebar: {
      imageDesktop: {
        url: data.wordpressWpGatsbyPage.acf.banner_sidebar.image_desktop.source_url,
        alt: data.wordpressWpGatsbyPage.acf.banner_sidebar.image_desktop.alt_text,
      },
      imageMobile: {
        url: data.wordpressWpGatsbyPage.acf.banner_sidebar.image_mobile.source_url,
        alt: data.wordpressWpGatsbyPage.acf.banner_sidebar.image_mobile.alt_text,
      },
      active: data.wordpressWpGatsbyPage.acf.banner_sidebar.active,
      link: data.wordpressWpGatsbyPage.acf.banner_sidebar.link,
    },
    top_searchs_title: data.wordpressWpGatsbyPage.acf.top_searchs_title,
    product_budget: data.wordpressWpGatsbyPage.acf.product_budget,
    topSearchs: data.wordpressWpGatsbyPage.acf.top_searchs.split('\r\n'),
  }

  const negotiationCode = data.negotiationCode.negotiation_code ? data.negotiationCode.negotiation_code : false;
  
  const mostWantedItens =
    data.allMostWantedExams.nodes.sort(
      (a,b) => a.exams_order - b.exams_order
    );

  return (
    <ProductProvider productState={{ productsData }}>
      <Showcase mostWanted={ mostWantedItens } negotiationCode={ negotiationCode }/>
    </ProductProvider>
  )
}

export default ShowcaseContainer
